import React, { useState, useCallback } from 'react';
import { Button, Modal } from 'components';
import ModalContent from 'pages/home/Content';
import { PostContainer } from 'pages/profile/TabPages.style';
import { useSelector } from 'react-redux';
import PostList from 'pages/home/PostList';
import { useTranslation } from 'react-i18next';

const PostTab = () => {
  const [postModalOpen, setPostOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('Create a post');
  const { activityList } = useSelector((state) => state.PostActivitySlice);
  const {t} = useTranslation();

  const changeModal = useCallback((data) => {
    setModalTitle(data);
  }, []);

  const closePostModal = useCallback(() => {
    setPostOpenModal(false);
  }, []);

  return (
    <PostContainer>
      <div className="empty-post">
        <PostList view={'profile'} />
        {activityList?.rows?.data?.length === 0 && (
          <Button
            onClick={() => setPostOpenModal(true)}
            label={t('HomePage.CreateYourPost')}
            variant="text"
            className="profile-create-post"
          />
        )}
        <Modal
          modalchanges="postModal"
          content={<ModalContent uploadImage={(data) => changeModal(data)} modalTitle={t('homepage.Create Post')} />}
          openModal={postModalOpen}
          modelTitle={modalTitle}
          closable
          handleCancelModal={() => closePostModal(false)}
        />
      </div>
    </PostContainer>
  );
};
export default PostTab;
